module.exports = __webpack_public_path__ + "assets/elsa-logo-2.6d1124bc.svg";